export const sportsbookColourMapping = {
    "FanDuel": "#0078ff",
    "Betway (Alaska)": "#0078ff",
    "DraftKings": "#61b50e",
    "Caesars": "#bc9e5f",
    "Kambi": "this is like 5 diff books",
    "PointsBet": "#ed1a42",
    "bet365": "#027b5b",
    "BetMGM": "#bfa971",
    "Betano": "#e44425",
    "Bet99": "#12562d",
    "BET99": "#12562d",
    "Betway":  "#00cc2b",
    "Bodog": "#c50201",
    "Bovada": "#c50201",
    "SportsInteraction": "#f48720",
    "Hard Rock": "#6a46f3",
    "Fliff": "#41e359",
    "WynnBet": "#c48f01",
    "SI Sportsbook": "#ee3f33",
    "Pinnacle": "#ff5402",
    "bet105": "#ff5402",
    "theScoreBet": "#ffbf00",
    "theScore": "#ffbf00",
    "SuperBook": "#f2b825",
    "Fanatics": "#e53c2d",
    "ESPN": "#1cf4cb",
    "Proline": "#33b45a",
    "PowerPlay": "#b9051f",
    "PrizePicks": "#d6962f",
    "Drafters": "#d1222a",
    "Fitzdares": "#ff4500",
    "BetOnline": "#ee3536",
    "PlayNow": "#b41c35",
    "TonyBet": "#8f00ff",
    "BookMaker": "#fec700",
    "Betfred": "#d6173f",
    "BetVictor": "#64c5f1",
    "Rebet": "#fc5333",
    "NEO.bet": "#e90041",
    "UBet": "#00acfe",
    "Thrillz": "#d681d1",
    "ProphetX": "#5ec19f",
    "Novig": "#7acffe",
    "Action247": "#f12634",
    "Shuffle": "#876ef0",
    "Polymarket": "#2d5dff",
    "ParlayPlay": "#fecf12",
    "JuiceBet": "#ff0004",
    "TitanPlay": "#f69e2d",
    "Stake": "#ffffff",
    "MyBookie": "#d96a25",
    "Play Alberta": "#012b66",
    "Bally Bet": "#C8102E",
    "1XBet": "#ffcc00",
    "888sport": "#ff6600",
    "Action 24/7": "#f12634",
    "BC.GAME": "#00d4ff",
    "Bet Right": "#00a651",
    "BetAnySports": "#1a73e8",
    "BetDEX": "#6366f1",
    "BetDSI": "#ff6b35",
    "BetDSI (Superbook)": "#f2b825",
    "Props Builder": "#ee3536",
    "BetOpenly": "#4f46e5",
    "BetOpenly (Instant DFS)": "#4f46e5",
    "BetRivers": "#1a73e8",
    "BetRivers (New York)": "#1a73e8",
    "BetUS": "#ff0000",
    "BetVictor": "#64c5f1",
    "Betcris": "#c8102e",
    "Betfair": "#003274",
    "Betfair Exchange": "#003274",
    "Betfair Exchange (Lay)": "#003274",
    "Betnacional": "#ff6b00",
    "Betplay": "#00d4aa",
    "Betr": "#000000",
    "Betr Picks": "#000000",
    "Betr Picks (All)": "#000000",
    "Betr Picks (BOOSTED)": "#ff0000",
    "Betsafe": "#ff6600",
    "Betsson": "#00a651",
    "Boom Fantasy (5 Pick Insured)": "#ff6b35",
    "Borgata": "#c8102e",
    "Casumo": "#ff6b00",
    "Circa Sports": "#1a73e8",
    "Circa Vegas": "#1a73e8",
    "Codere": "#c8102e",
    "Coolbet": "#00d4ff",
    "Crab Sports": "#ff6b35",
    "Dabble (3 or 5 Pick)": "#6366f1",
    "Dabble (Australia)": "#6366f1",
    "Dabble": "#6366f1",
    "Dafabet": "#ff6600",
    "Desert Diamond": "#c8102e",
    "DraftKings (Pick 6)": "#61b50e",
    "ESPN BET": "#1cf4cb",
    "Elite Bet": "#1cf4cb",
    "FanDuel (Ontario)": "#0078ff",
    "FireKeepers": "#c8102e",
    "Four Winds": "#1a73e8",
    "GGBet": "#ff6b00",
    "Galera.bet": "#00d4aa",
    "Golden Nugget": "#ffd700",
    "HotStreak": "#ff6b35",
    "Kutt": "#6366f1",
    "Ladbrokes": "#c8102e",
    "Ladbrokes (Australia)": "#c8102e",
    "LeoVegas": "#ff6b00",
    "Mise-o-jeu": "#1a73e8",
    "Neds": "#ff6600",
    "NorthStar Bets": "#1a73e8",
    "Picklebet": "#00d4aa",
    "Pinny": "#ff5402",
    "Play Eagle": "#1a73e8",
    "PointsBet (Australia)": "#ed1a42",
    "PointsBet (Ontario)": "#ed1a42",
    "Betly": "#1a73e8",
    "PrizePicks (5 or 6 Pick Flex)": "#d6962f",
    "PrizePicks (Demons and Goblins)": "#d6962f",
    "Prophet X": "#5ec19f",
    "Rebet Props City": "#fc5333",
    "Resorts World Bet": "#c8102e",
    "SBOBET": "#ff6600",
    "STN Sports": "#1a73e8",
    "SX Bet": "#6366f1",
    "Sleeper": "#00d4ff",
    "Sportingbet": "#ef1a22",
    "Sports Interaction": "#f48720",
    "Sportsbet": "#00a651",
    "Sportsbetting.ag": "#ff6600",
    "Sporttrade": "#1a73e8",
    "Sporttrade (Colorado)": "#1a73e8",
    "Sportzino": "#6366f1",
    "SugarHouse": "#1a73e8",
    "Superbet": "#ff6b00",
    "TAB": "#c8102e",
    "TAB (New Zealand)": "#c8102e",
    "TABtouch": "#c8102e",
    "Thrillzz": "#d681d1",
    "TopSport": "#ff6600",
    "TwinSpires": "#1a73e8",
    "Underdog Fantasy": "#ff6b35",
    "Underdog Fantasy (3 or 5 Pick)": "#ff6b35",
    "Underdog Fantasy (6 Pick)": "#ff6b35",
    "Underdog Sportsbook": "#ff6b35",
    "Unibet": "#bada55",
    "Unibet (Australia)": "#bada55",
    "Unibet (United Kingdom)": "#bada55",
    "Vivid Picks": "#6366f1",
    "Vivid Picks (4 Pick)": "#6366f1",
    "William Hill": "#c8102e",
    "Wind Creek": "#1a73e8",
    "Tipico": "#ff6600",
    "XBet": "#ffcc00",
    "betJACK": "#ff6b35",
    "betPARX": "#1a73e8",
    "betr (Australia)": "#000000",
    "betwhale": "#00d4ff",
    "bwin": "#ff6600",
    "partypoker": "#ff6b00",
    "Caesars (Louisiana)": "#bc9e5f",
    "Caesars (Maine)": "#bc9e5f",
    "Caesars (New York)": "#bc9e5f",
    "Caesars (Ontario)": "#bc9e5f",
    "Caesars (Pennsylvania)": "#bc9e5f",
    "Caesars (Tennessee)": "#bc9e5f"
  }
  